"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REGEX = void 0;
exports.REGEX = {
    WRITE_OPERATION_PATTERN: /^(INSERT|UPDATE|DELETE|MERGE|DROP|TRUNCATE|REPLACE|ALTER|CREATE)/i,
    REMOVE_TRAILING_SEMICOLON: /;\s*$/
};
